import {
  animate,
  query,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const authRouteAnimation = trigger('authRouteAnim', [
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
        }),
      ],
      { optional: true },
    ),
    query(
      ':leave',
      [
        animate(
          '260ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({ opacity: 0, transform: 'translateX(-18px)' }),
        ),
      ],
      { optional: true },
    ),
    query(
      ':enter',
      [
        style({
          opacity: 0,
          transform: 'translateX(28px) scale(0.985)',
        }),
        animate(
          '300ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({ opacity: 1, transform: 'translateX(0) scale(1)' }),
        ),
      ],
      { optional: true },
    ),
  ]),
]);
